import { useQuery, useQueryClient } from "@tanstack/react-query";

import { getFootprintingBeefManureAdditive, getFootprintingBeefManureAdditiveAdmin } from "services";

import { getEnvironment } from "utils";

import { FOOTPRINTING_BEEF_MANURE_ADDITIVE } from "consts";

export const useGetFootprintingBeefManureAdditive = (primaryDataId?: string) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();
  return useQuery(
    {
      queryKey: [FOOTPRINTING_BEEF_MANURE_ADDITIVE, primaryDataId, isAdmin],
      queryFn: () => (isAdmin ? getFootprintingBeefManureAdditiveAdmin(primaryDataId ?? "") : getFootprintingBeefManureAdditive(primaryDataId ?? "")),
      enabled: !!primaryDataId,
      gcTime: 0,
    },
    queryClient
  );
};
